import React, { memo } from 'react';

import styles from '../login.module.scss';

import Typography from '@smart-tv/components/typography';
import testIds from '@smart-tv/e2e/shared/variables';

interface Props {
  errorMsg?: string;
  errorCode?: number;
}

export const LoginError = (props: Props) => {
  const { errorMsg, errorCode } = props;

  if (!errorMsg) return null;

  return (
    <div className={styles['login-error']} data-testid={testIds.login.errorMessage}>
      <Typography className={styles['login-error__header']} variant="caption" fontWeight="bold">
        {errorMsg && errorMsg}
        {errorCode && ` [${errorCode}]`}
      </Typography>
    </div>
  );
};

export default memo(LoginError);
